import {Component, OnInit, HostListener} from '@angular/core'
import {AdminService} from '../services/admin.service'
import {UserSearchForm} from '../models/data-model'
import {Router} from '@angular/router'
import {GlobalDataService} from '../../housekeeping/services/global-data.service'
import {Angular2Csv} from 'angular2-csv/Angular2-csv';
import * as moment from 'moment';
declare var jQuery: any;
@Component({
    selector: 'app-admin',
    templateUrl: '../views/admin.component.html',
    styleUrls: ['../css/admin.component.css']
})
export class AdminComponent implements OnInit {
    public $j = jQuery.noConflict();
    public adminExportStatus: boolean = true
    public userId: any;
    public roleId: any;
    public offset = 0;
    public limit = 10;
    public showAdvance: boolean = false;
    public showAdvanceLink = true;
    public columns: any = [];
    public headerUsersList: any = [];
    public userList: any;
    public noData: boolean = false;
    public showBack: boolean = false;
    public showNext: boolean = false;
    public advanceOffset: number = 0;
    public dealerList: any;
    public userSearchObj = new UserSearchForm("", "", "", null, "", this.userId, this.offset, this.limit, true,[]);
    public lastName: string = "";
    public showsubmission: boolean = true;
    public showsubmissionrange: boolean = false;
    public advanceSearchList: boolean = false;
    public normalSearch: boolean = false;
    public basicOffset: number = 0;
    public labelData: any = [];
    public finalExportData: any = [];
    public totalRecords = 0;
    public pageSize = 10;
    p: number;
    public pageExist: any;
    public countryList: any = [];
    public countrySelected: any = [];
    public isCountryAll: boolean = false;
    public countryCount: number = 0;
    public countryIndex: any = [];
    public countrySettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'namecode',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        itemsShowLimit: 1,
        allowSearchFilter: true
    };

    constructor(public _adminServcie: AdminService, public _router: Router, public _dataService: GlobalDataService) {}

    ngOnInit() {
         if (sessionStorage.getItem("pageLimit") !== null) {
      this.limit = Number(sessionStorage.getItem("pageLimit"));
      this.pageSize = Number(sessionStorage.getItem("pageLimit"))

    }
        //this.$j('[data-toggle="tooltip"]').tooltip("enable");
        //this.userId = localStorage.getItem('userId')
        this.userId = sessionStorage.getItem('userId');

        if (sessionStorage.getItem('roleId') != "SYSADM" && sessionStorage.getItem('roleId') != "SUSER") {
          //console.log(sessionStorage.getItem('roleId'))
            this._router.navigate(['dashboard'])
        }
        this.prepareAdminTableData();
        let path = this._dataService.getPreviousUrl();
        if (!path.includes('/admin/detail')) {
            this.getUserList()
        }
        if (path.includes('/admin/detail')) {
            if (sessionStorage.getItem("normalSearch") !== null) {
                this.basicOffset = Number(sessionStorage.getItem("normalSearch"));
                if (this.basicOffset > 0) {
                    this.showBack = true
                }
                this.lastName = sessionStorage.getItem("lastname");
                this.basicSearch()
            }
            else if (sessionStorage.getItem("advanceSearch") !== null) {
                this.advanceOffset = Number(sessionStorage.getItem("advanceSearch"));
                if (this.advanceOffset > 0) {
                    this.showBack = true
                }
                this.userSearchObj = JSON.parse(sessionStorage.getItem("advancesearchfields"));
                this.lastName = this.userSearchObj.lastName;
                this.advanceSearch()
            }
            else if (sessionStorage.getItem("list") !== null) {
                this.offset = Number(sessionStorage.getItem("list"));
                if (this.offset > 0) {
                    this.showBack = true
                }
                this.getUserList()
            } else {
                this.getUserList()
            }
        }
        this.getDealerList()
        this.getCountryList()
    }

    /**
    * @author Nagendra
    * @description Preparing User List data
    */
    getUserList() {
        this.userList = [];
        this.advanceSearchList = false;
        this.normalSearch = false;
        this.basicOffset = 0;
        this.advanceOffset = 0;
        this._adminServcie.getUserList(this.userId, this.offset, this.limit, (result) => {
            this.userList = result.beans;
            if (this.offset == 0) {
                sessionStorage.removeItem("totalCount");
                this.totalRecords = result.pageCount
                sessionStorage.setItem("totalCount", result.pageCount);
            }

            if (this.userList == '') {
                this.showNext = false;
                this.noData = true;
            }
            else if (this.userList.length < 10) {
                this.showNext = false;
                this.noData = false;
            }
            else if (this.userList.length == 10) {
                this.showNext = true;
                this.noData = false;
            }
            else {
                this.showNext = false;
                this.showBack = false;
                this.noData = true;
            }
        });
    }

    /**
     * @author Nagendra
     * @description To get row and label fields data
     */
    prepareAdminTableData() {
        this._adminServcie.getUserList(this.userId, this.offset, this.limit, (result) => {
            let values = Array.prototype.slice.call(result.beans, 0);
            values.forEach(value => {
                this.headerUsersList = Object.keys(value);

            });
        });
        this.labelData = [{name: "ID", preference: "id"}, {name: "First Name", preference: "firstName"}, {name: "Last Name", preference: "lastName"}, {name: "Dealership", preference: "dealership"}, {name: "Email", preference: "email"}, {name: "User Level", preference: "userLevel"}, {name: "Email Notification", preference: "emailNotification"}, {name: "Status", preference: "status"}]
    }

    /**
    * @author Nagendra
    * @description Search by lastName
    */
    basicSearch() {
        this.userSearchObj.isPagination = false;
        this.userList = [];
        this.normalSearch = true;
        this.offset = 0;
        this.advanceOffset = 0;
        if (this.basicOffset == 0) {this.showBack = false;}
        this.advanceSearchList = false;
        this._adminServcie.adminBasicSearch(this.userId, this.lastName, this.offset, this.limit, (result) => {
            this.userList = result.beans;
            if (this.basicOffset == 0) {
                sessionStorage.removeItem("totalCount");
                this.totalRecords = result.pageCount;
                sessionStorage.setItem("totalCount", result.pageCount);
            }
            if (result.length != 0) {
                this.adminExportStatus = false
                //this.$j('[data-toggle="tooltip"]').tooltip("disable");
            }
            if (this.userList == '') {
                this.showNext = false;
                this.noData = true;
            }
            else if (this.userList.length < 10) {
                this.showNext = false;
                this.noData = false;
            }
            else if (this.userList.length == 10) {
                this.showNext = true;
                this.noData = false;
            }
            else {
                this.showNext = false;
                this.showBack = false;
                this.noData = true;
            }
        });
    }

    /**
     * @author Nagendra
     * @description Advance Search
     */
    advanceSearch() {
        this.userSearchObj.isPagination = false;
        this.userList = [];
        this.advanceSearchList = true;
        this.offset = 0;
        this.basicOffset = 0;
        if (this.advanceOffset == 0) {this.showBack = false;}
        this.showAdvanceLink = true;
        this.userSearchObj.userId = this.userId;
        this.userSearchObj.lastName = this.lastName;
        this.userSearchObj.offset = this.advanceOffset;
        this.noData = false;

         if (Object.keys(this.countrySelected).length > 0 && this.countrySelected != undefined && this.isCountryAll != true) {

       Object.keys(this.countrySelected).map(key => (
       this.userSearchObj.countryIds.push(
  this.countrySelected[key]['id'])))
         }

        this._adminServcie.adminAdvanceSearch(this.userSearchObj, (result) => {
            this.showAdvance = false;
            this.userList = result.beans;
            if (this.advanceOffset == 0) {
                sessionStorage.removeItem("totalCount");
                this.totalRecords = result.pageCount;
                sessionStorage.setItem("totalCount", result.pageCount);
            }
            if (result.length != 0) {
                this.adminExportStatus = false
                //this.$j('[data-toggle="tooltip"]').tooltip("disable");
            }
            if (this.userList == '') {
                this.showNext = false;
                this.noData = true;
            }
            else if (this.userList.length < 10) {
                this.showNext = false;
                this.noData = false;
            }
            else if (this.userList.length == 10) {
                this.showNext = true;
                this.noData = false;
            }
            else {
                this.showNext = false;
                this.showBack = false;
                this.noData = true;
            }
        })
    }

    /**
     * @author Nagendra
     * @description Get Previous Page
     */
    GoBack() {
        this.offset -= 10;
        if (this.offset == 0) {
            this.showBack = false;
            this.noData = false;
        }
        if (this.advanceSearchList == true) {
            this.offset = 0;
            this.basicOffset = 0;
            this.advanceOffset -= 10;
            if (this.advanceOffset == 0) {
                this.showBack = false;
                this.noData = false;
            }
            else if (this.advanceOffset > 0) {
                this.showNext = true;
            }
            this.advanceSearch();
        }
        else if (this.normalSearch == true) {
            this.offset = 0;
            this.advanceOffset = 0;
            this.basicOffset -= 10;
            if (this.basicOffset == 0) {
                this.showBack = false;
                this.noData = false;
            }
            if (this.basicOffset > 0) {
                this.showNext = true;
            }
            this.basicSearch();
        }
        else {this.getUserList();}

    }
    /**
     * @author Nagendra
     * @description Get Next Page
     */
    nextPage() {
        this.showBack = false;
        this.offset += 10;
        if (this.offset > 0) {
            this.showBack = true;
        }
        if (this.advanceSearchList == true) {
            this.offset = 0;
            this.basicOffset = 0;
            this.advanceOffset += 10;
            if (this.advanceOffset > 0) {
                this.showBack = true;
            }
            this.advanceSearch();
        }
        else if (this.normalSearch == true) {
            this.offset = 0;
            this.advanceOffset = 0;
            this.basicOffset += 10;
            if (this.basicOffset > 0) {
                this.showBack = true;
            }
            this.basicSearch();
        }
        else {
            this.getUserList();
        }
    }

    /**
    * @author Nagendra
    * @description show Users advance search page
    */
    showadvanceSearch(value) {
        this.showAdvance = value;
        if (this.showAdvance) {
            this.showBack = false;
            this.showAdvanceLink = false
        } else {
//        console.log("entered")
            this.offset = 0;
            this.basicOffset = 0;
            this.advanceOffset = 0;
            this.lastName = "";
            this.showsubmission = true;
            this.showsubmissionrange = false;
            this.showAdvanceLink = true;
             this.adminExportStatus = true
            //this.$j('[data-toggle="tooltip"]').tooltip("enable");
            this.getUserList();
        }
    }

    /**
    * @author Nagendra
    * @description Get Dealer List
    */
    getDealerList() {
        this._adminServcie.getUserDealer(result => {
            this.dealerList = result;
        })
    }

    /**
       * @author Sowmya
       * @description redirect to admin detail page
       */
    viewAdminDetails(adminId) {
        if (this.normalSearch == true) {
            sessionStorage.removeItem("advanceSearch");
            sessionStorage.removeItem("advancesearchfields");
            sessionStorage.removeItem("list");
            sessionStorage.setItem("normalSearch", this.basicOffset.toString());
            sessionStorage.setItem("lastname", this.lastName);
        }
        else if (this.advanceSearchList == true) {
            sessionStorage.removeItem("normalSearch");
            sessionStorage.removeItem("lastname");
            sessionStorage.removeItem("list");
            sessionStorage.setItem("advanceSearch", this.advanceOffset.toString());
            sessionStorage.setItem("advancesearchfields", JSON.stringify(this.userSearchObj));
        }
        else {
            sessionStorage.removeItem("normalSearch");
            sessionStorage.removeItem("lastname");
            sessionStorage.removeItem("advanceSearch");
            sessionStorage.removeItem("advancesearchfields");
            sessionStorage.setItem("list", this.offset.toString())
        }
        this._router.navigate(['admin/detail/' + adminId])
    }

    /**
    * @author Nagendra
    * @description To hide Advance Search on click outside of div
    */
    @HostListener('document:click', ['$event']) clickedOutside() {
        if (this.showAdvance == true) {
            this.showAdvance = false;
            this.showAdvanceLink = true
        }
    }

    clickedInside($event: Event) {
        $event.preventDefault();    // prevent default event of that browser
        $event.stopPropagation();  // that will stop propagation on lower layers
    }


    setOffset() {
        this.basicOffset = 0;
        this.advanceOffset = 0;
    }

    /*
  * @author Vanitha
  * @uses To change page size for list
  * @date 20-11-2019
  */
    pageChanged(event) {
        if (this.pageExist != event) {
            this.pageExist = event;
            if (this.advanceSearchList == true) {
                this.offset = 0;
                this.basicOffset = 0;
                if (event >= 1) {
                    this.advanceOffset = (this.pageSize * (event - 1))
                    //  console.log("****************advanceOffset******************" + this.advanceOffset);
                } else {
                    this.advanceOffset = 0
                }
                this.advanceSearch();
            } else if (this.normalSearch == true) {
                this.offset = 0;
                this.advanceOffset = 0;
                if (event >= 1) {
                    this.basicOffset = (this.pageSize * (event - 1))
                    //   console.log("****************basicOffset******************" + this.basicOffset);
                } else {
                    this.basicOffset = 0
                }
                this.basicSearch();
            } else {
                if (event >= 1) {
                    this.offset = (this.pageSize * (event - 1))
                    //  console.log("****************normal******************" + this.offset);
                } else {
                    this.offset = 0
                }
                this.getUserList();
            }
        }
    }


    /*
  * @author Vanitha
  * @uses To change page size for list
  * @date 20-11-2019
  */

    changepageSize() {
        this.limit = this.pageSize;
        if (sessionStorage.getItem("pageLimit") !== null) {
            sessionStorage.removeItem("pageLimit")
        }
        sessionStorage.setItem("pageLimit", this.limit.toString());
        this._adminServcie.updatePageLimit(this.userId, this.limit, result => {
        })
        if (this.advanceSearchList == true) {
            this.advanceSearch();
        } else if (this.normalSearch == true) {
            this.basicSearch();
        } else {
            this.getUserList();
        }
    }
    getCountryList() {
            this._adminServcie.getCountryList(this.userId, (result) => {
                result.forEach(obj => {
                    this.countryList.push({
                        id: obj.id,
                        name: obj.name,
                        code: obj.code,
                        namecode: obj.code + '(' + obj.name + ')'
                    })
                })
            });



    }

    onCountrySelectAll(value) {
        this.isCountryAll = true
    }

    onCountryDeSelectAll(value) {
        this.isCountryAll = false
    }
    onCountrySelect(value) {
        this.isCountryAll = false
    }

    onCountryDeSelect(value) {
        this.isCountryAll = false
    }

    /*
* @author Vanitha
* @uses for export functional  ity
* @date 21-11-2019
   */

    exportAdminList() {
        let newHeader = [];
        let newcases;
        let column;
        this.finalExportData = [];
        this.userSearchObj.isPagination = false;
        this.labelData.forEach(prefprop => {
            newHeader.push(prefprop.name);
        });
        if (this.normalSearch == true) {
            this._adminServcie.adminBasicSearch(this.userId, this.lastName,0,0, (result) => {
                result.beans.forEach(eachObj => {
                    newcases = {};
                    this.labelData.forEach(prefprop => {
                        column = prefprop.preference;
                        if (eachObj[column] != "" || eachObj[column] != null) {
                            newcases[prefprop.name] = eachObj[column];
                        } else {
                            newcases[prefprop.name] = null;
                        }
                    });
                    this.finalExportData.push(newcases);
                });
                var today: string = moment().format('D MMM YYYY HH:mm:ss');
                var options = {
                    showLabels: true,
                    headers: newHeader
                };
                new Angular2Csv(this.finalExportData, 'My_Report' + today, options);
            });
        }
        else if (this.advanceSearchList == true) {

            this._adminServcie.adminAdvanceSearch(this.userSearchObj, (result) => {
                result.beans.forEach(eachObj => {
                    newcases = {};
                    this.labelData.forEach(prefprop => {
                        column = prefprop.preference;
                        if (eachObj[column] != "" || eachObj[column] != null) {
                            newcases[prefprop.name] = eachObj[column];
                        }
                        else {
                            newcases[prefprop.name] = null;
                        }
                    });
                    this.finalExportData.push(newcases);
                });
                var today: string = moment().format('D MMM YYYY HH:mm:ss');
                var options = {
                    showLabels: true,
                    headers: newHeader
                };
                new Angular2Csv(this.finalExportData, 'My_Report' + today, options);
            });
        }
        else {
            this._adminServcie.getUserList(this.userId, this.offset, this.limit, (result) => {
                result.beans.forEach(eachObj => {
                    newcases = {};
                    this.labelData.forEach(prefprop => {
                        column = prefprop.preference;
                        if (eachObj[column] != "" || eachObj[column] != null) {
                            newcases[prefprop.name] = eachObj[column];
                        } else {
                            newcases[prefprop.name] = null;
                        }
                    });
                    this.finalExportData.push(newcases);
                });
                var today: string = moment().format('D MMM YYYY HH:mm:ss');
                var options = {
                    showLabels: true,
                    headers: newHeader
                };
                new Angular2Csv(this.finalExportData, 'My_Report' + today, options);
            })
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/admin/components/admin.component.ts